import React from "react";
import "./CustomButton.css";

export default function CustomButton({
  children,
  kind = "primary",   // 'primary' | 'secondary' | 'tertiary' | 'ghost'
  size = "md",        // 'md' | 'sm'
  fullWidth = false,
  type = "button",
  disabled = false,
  className = "",
  onClick,
  ...rest
}) {
  const classes = [
    "cb-btn",
    `cb-btn--${kind}`,
    `cb-btn--${size}`,
    fullWidth ? "cb-btn--full" : "",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}
